import { render } from "./HeroiconsSolidSortAscending.vue?vue&type=template&id=045934b9"
const script = {}

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSortAscending.vue"]])

export default __exports__